import { Observable, Subject, catchError, iif, of, switchMap, take, takeUntil } from 'rxjs';

const defaultErrorHandler = (error: unknown) => {
    console.error(error);
};

//Temp until we refactor it
/* eslint-disable max-params */
export const protectSubscription = <T, U = unknown>
    (
        $observable: Observable<T>,
        successHandler: (data: T) => void,
        errorHandler: (error: U) => void = defaultErrorHandler,
        shouldEmitSubscriptionOnce = false,
        cancelObservable$: Subject<boolean> = new Subject<boolean>()
    ) => {
    return $observable.pipe(
        catchError((error) => {
            errorHandler(error);
            return [];
        }),
        switchMap(data =>
            iif(
                () => shouldEmitSubscriptionOnce,
                of(data).pipe(take(1)),
                of(data)
            )
        ),
        takeUntil(cancelObservable$)
    ).subscribe(data => successHandler(data));
};
/* eslint-enable max-params */